<template>
	<div id="shopcar">
		<HeaderTop></HeaderTop>
		<HeaderTitle :pageName="$t('header.sopC')" :topType="toptype"></HeaderTitle>
		<Back />
		<section class="word">
			<div class="content content-box-shop-car flex_between">
				<div class="goods-msg">{{$t('Shopping.Allproducts')}} {{goods.length > 0 ? goods.length : ''}}</div>
				<div class="g-r">
					<div class="g-r-font">{{$t('Shopping.Total')}}：</div>
					<div class="money font1">{{`${$type == 1?'￥':'$'}`+(allPrice / 100).toFixed(2)}}</div>
				</div>
			</div>

			<div class="goods-car">
				<div class="handle">
					<div class="goodsimg" @click="allChose">
						<span class="checkbox" :class="{'chose' : choseAll}"></span>{{$t('Shopping.Selectall')}}
					</div>
					<div class="title goods-detaile">{{$t('Shopping.spinformation')}}</div>
					<div class="title price">{{$t('Shopping.UnitPrice')}}</div>
					<div class="title num">{{$t('Shopping.number')}}</div>
					<div class="title money-b">{{$t('Shopping.money')}}</div>
					<div class="title handle-de">{{$t('Shopping.operation')}}</div>
				</div>
				<div class="goods-list" v-for="(item,index) in goods" :key="index">
					<div class="goodsimg">
						<span class="checkbox" :class="{'chose' : item.chose}" @click="choseGoods(item)"></span>
						<img :src="item.img ? $img+item.img.split(',')[0] : ''" class="img" alt="">
					</div>
					<div class="title goods-detaile">
						<span class="goods-title font1">{{item.msg}}</span>
						<div class="Specifications font1">
							<div class="show">{{item.spe}}</div>
							<div>{{item.size}}</div>
							<div>
								<div class="price-index-items" v-for="item1 in item.priceIndex">
									<p>{{$t('product.buy') + item1.num}}</p>
									<p>{{$t('product.unitPrice') + `${$type == 1?'：￥':'：$'}` + item1.price / 100}}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="title price-n price">
						{{`${$type == 1?'￥':'$'}`+(item.price / 100).toFixed(2)}}
						<p style="color: #ff5a39;">原价：{{`${$type == 1?'￥':'$'}`+item.price0}}</p>
					</div>
					<div class="title num goods-num">
						<span class="handel-btn" @click="minus(item,index)">-</span>
						<input class="number" @keyup="changeValue" @blur="changeValue" :data-index0="index" type="text" v-model="goods[index].num" />
						<span class="handel-btn" @click="add(item,index)">+</span>
					</div>
					<div class="font1 money-b money">{{`${$type == 1?'￥':'$'}`+(item.money / 100).toFixed(2)}}</div>
					<div class="title handle-de" @click="deletes(item.id)">{{$t('Shopping.delete')}}</div>
				</div>
			</div>

			<div class="Settlement">
				<div class="sett-l">
					<span class="checkbox" :class="{'chose' : choseAll}" @click="allChose"></span>
					<span class="font1">{{$t('Shopping.Selectall')}}</span>
				</div>
				<div class="sett-r">
					<div>{{$t('Shopping.Selected')}} <em>{{checkedGoodsCount}}</em> 件</div>
					<span>{{$t('Shopping.Total')}}：</span>
					<span class="money">{{`${$type == 1?'￥':'$'}`+(allPrice / 100).toFixed(2)}}</span>
					<a :class="checkedGoodsCount <= 0 ? 'black-btn' : ''" href="javascript:void(0)" @click="settlementToPay">{{$t('Shopping.settlement')}}</a>
				</div>
			</div>
		</section>
		<PageFooter></PageFooter>
		<LoginPop @closePop="closeFn" v-show="!closePop"></LoginPop>
	</div>
</template>

<script>
	import HeaderTop from "../assembly/HeaderTop";
	import HeaderTitle from "../assembly/HeaderTitle";
	import PageFooter from "../assembly/PageFooter";
	import LoginPop from "../assembly/LoginPop";
	import Back from '../assembly/Back';
	import utils from '../../assets/js/utils';

	export default {
		name: "shopcar",
		components: {
			HeaderTop,
			HeaderTitle,
			PageFooter,
			LoginPop,
			Back
		},
		data() {
			return {
				pagename: "购物车",
				toptype: "line",
				byGoods: [],
				goods: [],
				choseAll: false, //全选
				allPrice: 0,
				closePop: true,
				token: '',
				checkedGoodsCount: 0, //选中的个数
			};
		},
		created() {
			this.token = sessionStorage.getItem('token');
			this.initData();
		},
		methods: {
			// 删除
			deletes(id) {
				let url = '/api/shop/car/del'
				let data = {
					carId: id,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.$message({
							message: this.$t('Tips.delsuc'),
							type: 'success'
						});
						this.initData();
					}
				})
			},
			//结算按钮
			settlementToPay() {
				if (this.checkedGoodsCount <= 0) {
					this.$message({
						type: 'warning',
						message: this.$t('Tips.shop')
					});
					return;
				}
				let carIds = '';
				this.byGoods.forEach(item => {
					carIds += item.id + ','
				});
				carIds = carIds.substring(0, carIds.length - 1);
				//跳转提交订单页面
				this.$router.push({
					path: '/submit/order',
					query: {
						carIds
					}
				});
			},
			initData() {
				this.$get('api/shop/car/list', {
					token: this.token
				}).then(res => {
					if (res.code === 0) {
						let result = res.data,
							goods = [];
						result.forEach(item => {
							let price = item.unitPrice;
							let {
								priceIndex
							} = item;
							let temp = [];
							if (priceIndex && priceIndex !== 'null') {
								temp = JSON.parse(priceIndex).sort((a, b) => a.num - b.num);
								temp.forEach(item1 => {
									if (item1.num <= item.num) {
										price = item1.price / 100;
									}
								});
							}
							goods.push({
								id: item.carId,
								msg: item.productNum,
								spe: "产品描述：" + item.productDescribe,
								size: "产品编号：" + item.productNum,
								price0: (item.unitPrice / 100).toFixed(2),
								price: price.toFixed(2),
								num: item.num,
								money: (price * item.num).toFixed(2),
								img: item.productImg,
								startBuy: item.startBuy,
								priceIndex: temp
							});
						});
						this.goods = goods;
					}
				});
			},
			//当值改变的时候
			changeValue(e) {
				let index = e.target.dataset['index0'],
					value = e.target.value + '';
				value = value.replace(/[^\d]/g, '');
				value = Number(value);
				//限制只能最多输入99999，最小也得大于0
				let startBuy = this.goods[index].startBuy;
				let nums = value <= startBuy ? startBuy : (value > 99999 ? 99999 : value),
					i = Number(index);
				this.goods[i].num = nums;
				//防抖去修改购物车产品数量
				utils.antiShake(() => {
					this.$post('api/shop/car/update', {
						carId: this.goods[i].id,
						num: nums,
						token: this.token
					}).then(res => {
						if (res.code === 0) {
							this.goods[i].money = (nums * Number(this.goods[i].price)).toFixed(2);
							this.settlement();
						}
					});
				}, 300)();
			},
			//减
			minus(item, index) {
				this.changeValue({
					target: {
						dataset: {
							index0: index
						},
						value: item.num <= 1 ? 1 : item.num - 1
					}
				});
			},
			add(item, index) {
				this.changeValue({
					target: {
						dataset: {
							index0: index
						},
						value: item.num + 1
					}
				});
			},
			choseGoods(i) {
				if (i.chose) {
					this.$set(i, "chose", false);
				} else {
					this.$set(i, "chose", true);
				}
				this.settlement();
				this.checkSelectAll();
			},
			//校验是否全选和是否全不选
			checkSelectAll() {
				let flag = true;
				for (const item of this.goods) {
					if (!item.chose) {
						flag = false;
						break;
					}
				}
				this.choseAll = flag;
			},
			//全选 、 全不选
			allChose() {
				if (this.choseAll) {
					this.goods.forEach(item => {
						this.$set(item, "chose", false);
					});
					this.choseAll = false;
				} else {
					this.goods.forEach(item => {
						this.$set(item, "chose", true);
					});
					this.choseAll = true;
				}
				this.settlement();
			},
			//计算总金额等
			settlement() {
				let goods = [];
				let allP = 0,
					checkedGoodsCount = 0;
				this.goods.forEach((item) => {
					if (item.chose) {
						checkedGoodsCount++;
						goods.push(item);
						allP += Number(item.money)
					}
				});
				this.checkedGoodsCount = checkedGoodsCount;
				this.byGoods = goods;
				this.allPrice = allP;
			},
			//关闭登录弹窗
			closeFn(pop) {
				this.closePop = pop;
			}
		}
	};
</script>

<style scoped>
	.show {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	#shopcar {
		background: #fff;
		min-height: 100vh;
	}

	.content-box-shop-car {
		padding-top: 0 !important;
	}

	.content {
		padding-top: 49px;
		width: 100%;
	}

	.goods-msg {
		display: flex;
		justify-content: space-between;
		width: 100%;
		color: #0D79CF;
		font-size: 18px;
	}

	.g-l {
		color: #0d79cf;
		font-size: 18px;
		padding-bottom: 14px;
		border-bottom: 1px solid #0d79cf;
	}

	.g-r {
		display: flex;
		align-items: center;
		margin: 10px 0;
		/* width: 18%; */
	}

	.font1 {
		font-size: 14px;
	}

	.money {
		color: #ea2323;
		font-weight: bold;
	}

	.g-r-font {
		color: #000;
		font-size: 13px;
		width: 110px;
	}

	.g-r .money {
		margin-right: 14px;
	}

	.top-btn {
		width: 56px;
		height: 27px;
		background: #aaaaaa;
		color: #fff;
		font-size: 12px;
		text-align: center;
		line-height: 27px;
	}

	.goods-car {
		border: 1px solid #e2e2e2;
		width: 100%;
		box-sizing: border-box;
	}

	.goodsimg {
		width: 133px;
		padding: 16px 0;
		display: flex;
		align-items: center;
		padding-left: 21px;
	}

	.goods-list .goodsimg {
		padding-bottom: 0;
	}

	table {
		margin: 0;
		padding: 0;
		border-collapse: collapse;
		border-spacing: 0px;
	}

	.goods-list {
		border-bottom: 1px solid #e2e2e2;
		padding-bottom: 25px;
		display: flex;
	}

	.handle {
		box-sizing: border-box;
		background-color: #e2e2e2;
		font-size: 13px;
		color: #4a4a4a;
		display: flex;
		align-items: center;
	}

	.goods-list:last-child {
		border: 0;
	}

	.checkbox {
		width: 14px;
		height: 14px;
		display: inline-block;
		border: 1px solid #cacaca;
		background: #fff;
		border-radius: 2px;
		margin-right: 7px;
	}

	.title {
		font-size: 13px;
		color: #4a4a4a;
		text-align: left;
	}

	.goods-list .title {
		padding-top: 21px;
	}

	.goods-detaile {
		width: 519px;
		display: flex;
	}

	.price {
		width: 112px;
	}

	.num {
		width: 158px;
	}

	.money-b {
		width: 151px;
	}

	.handle-de {
		width: 128px;
	}

	.img {
		display: block;
		width: 80px;
		height: 80px;
		border: 1px solid #f1f1f1;
	}

	.goods-title {
		display: inline-block;
		width: 210px;
		text-align: left;
	}

	.Specifications {
		color: #666666;
		width: 200px;
		display: inline-block;
		margin-left: 50px;
	}

	.price-n {
		color: #1a1a1a;
		font-size: 14px;
		font-weight: bold;
	}

	.handel-btn {
		width: 30px;
		height: 30px;
		border: 1px solid #e2e2e2;
		display: inline-block;
		text-align: center;
		line-height: 30px;
		font-size: 14px;
		color: #1a1a1a;
		background: #e2e2e2;
	}

	.goods-num {
		display: flex;
	}

	.number {
		width: 56px;
		height: 30px;
		/*border-top: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;*/
		box-shadow: 0 0 0 1px #e2e2e2 inset;
		display: inline-block;
		text-align: center;
		line-height: 30px;
	}

	.money-b.money {
		text-align: left;
		padding-top: 21px;
	}

	.Settlement {
		display: flex;
		justify-content: space-between;
		width: 100%;
		background: #efefef;
		margin-top: 19px;
		margin-bottom: 193px;
	}

	.sett-l {
		display: flex;
		padding: 19px 0 19px 21px;
		align-items: center;
	}

	/* 	.sett-l .font1:nth-child(2n) {
		margin: 0 24px 0 38px;
	} */

	.sett-r {
		display: flex;
		align-items: center;
		font-size: 13px;
	}

	.sett-r em {
		color: #0976cd;
		font-style: normal;
	}

	.sett-r a {
		width: 116px;
		height: 100%;
		background-image: linear-gradient(#3f9fea, #0573cb);
		color: #fff;
		justify-content: center;
		align-items: center;
		display: flex;
		font-size: 18px;
		font-weight: bold;
		margin-left: 18px;
	}

	.chose {
		background: url("../../assets/images/g.png") center center no-repeat;
		background-size: 100%;
	}

	.black-btn {
		background: #999999 !important;
	}

	.price-index-items {
		display: flex;
		width: 100%;
	}

	.price-index-items>p:nth-child(1) {
		width: 40%;
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/components/shopCar/ShopCar.vue